import React, { useState } from 'react';
import { themes, activeTheme } from '../../theme/index';
import { applyTheme } from '../../theme/applyTheme';
import './ThemeSwitcher.css';

const ThemeSwitcher = ({ onClose }) => {
  const [selected, setSelected] = useState(
    () => localStorage.getItem('campusxl-theme') || activeTheme
  );

  const handleSelect = (key) => {
    setSelected(key);
    applyTheme(themes[key]);
    localStorage.setItem('campusxl-theme', key);
  };

  return (
    <div className="ts-overlay" onClick={onClose}>
      <div className="ts-modal" onClick={(e) => e.stopPropagation()}>

        <div className="ts-header">
          <div className="ts-title-wrap">
            <span className="ts-icon">🎨</span>
            <h2 className="ts-title">Choose Theme</h2>
          </div>
          <button className="ts-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="ts-grid">
          {Object.entries(themes).map(([key, theme]) => {
            const isActive = selected === key;
            return (
              <button
                key={key}
                className={`ts-card ${isActive ? 'ts-card--active' : ''}`}
                onClick={() => handleSelect(key)}
              >
                <div className="ts-swatches">
                  <span className="ts-swatch" style={{ background: theme.primary }} />
                  <span className="ts-swatch" style={{ background: theme.light }} />
                  <span className="ts-swatch" style={{ background: theme.dark }} />
                  <span className="ts-swatch" style={{ background: theme.cream }} />
                </div>
                <span className="ts-name">{theme.name}</span>
                {isActive && <span className="ts-check">✓</span>}
              </button>
            );
          })}
        </div>

        <p className="ts-hint">Long-press the logo to reopen this panel.</p>
      </div>
    </div>
  );
};

export default ThemeSwitcher;
